import {TRIP_DETAILS} from '../../utils/EDAP/ConversationDetails';
import {TRIP_MESSAGES} from '../../utils/EDAP/ConversationMessages';
import {TRIP_PAYMENTS} from '../../utils/EDAP/ConversationPayments';

export const ACTION_LOCATION_NAMES = {
    details: TRIP_DETAILS,
    messages: TRIP_MESSAGES,
    payments: TRIP_PAYMENTS,
};
